/* libs */
import { createLogic } from "redux-logic";
import axios from "axios";
import firebase from "firebase/app";
import "firebase/auth";

/* action helpers */
import * as ActionTypes from "../../actions/actionTypes";
import * as AppsActions from "../../actions/appsActions";
import * as constants from "../../constants";

const editAppLogic = createLogic({
	type: ActionTypes.EDIT_APP,
	// eslint-disable-next-line no-unused-vars
	process({ getState, action }, dispatch, done) {
		//TODO: dispatch action for creating a loader
		firebase
			.auth()
			.currentUser.getIdToken(true)
			.then(token => {
				var api = axios.create({
					baseURL: constants.BASE_API_URL,
					timeout: 20000,
					headers: { Authorization: "Bearer " + token },
				});
				api.put(`/apps/${action.appID}`, action.app)
					.then(() => {
						//TODO: dispatch action for stopping loader
						dispatch(AppsActions.editAppSuccess());
						if (action.callback) {
							action.callback();
						}
						done();
					})
					.catch(error => {
						//TODO: dispatch action for stopping loader
						dispatch(AppsActions.editAppFail(error));
						done();
					});
			});
	},
});

export default [editAppLogic];
